import React, { useContext, useReducer, createContext } from 'react';
import { subDays } from 'date-fns';
import produce from 'immer';
const ReportStateContext = createContext();
const ReportDispatchContext = createContext();

export const CHANGE_ID = 'CHANGE_ID';
export const CHANGE_MEMBERS = 'CHANGE_MEMBERS';
export const CHANGE_CREATOR = 'CHANGE_CREATOR';
export const CHANGE_GROUPS = 'CHANGE_GROUPS';
export const CHANGE_IS_APPLICATION = 'CHANGE_IS_APPLICATION';
export const CHANGE_DELETED = 'CHANGE_DELETED';
export const NEXT_PAGE = 'NEXT_PAGE';
export const PREVIOUS_PAGE = 'PREVIOUS_PAGE';
export const GO_TO_PAGE = 'GO_TO_PAGE';
export const CHANGE_DATE = 'CHANGE_DATE';
export const SET_PROPERTIES = 'SET_PROPERTIES';
export const CHANGE_NAME = 'CHANGE_NAME';
export const CHANGE_PARTICIPANT_NAME = 'CHANGE_PARTICIPANT_NAME';
export const CHANGE_EXTERNALID = 'CHANGE_EXTERNALID';
export const CHANGE_STATUS = 'CHANGE_STATUS';
export const RESET = 'RESET';

const initialState = () => ({
    selectedCreators: [],
    selectedUsers: [],
    selectedGroups: [],
    isApplication: false,
    startDate: subDays(new Date(), '7'),
    endDate: new Date(),
    page: 1,
    key: 'selection',
    showTimeline: false,
    lang: 'ES',
    documentId: [],
    header: '',
    deleted: false,
    name: '',
    participantName: '',
    externalId: '',
    status: []
})

const reducer = produce((draft, action) => {
    // eslint-disable-next-line default-case
    switch (action.type) {
        case CHANGE_DELETED:
            draft.deleted = !draft.deleted;
            draft.page = 1
            break;
        case CHANGE_NAME:
            draft.name = action.name
            draft.page = 1
            break;
        case CHANGE_EXTERNALID:
            draft.externalId = action.externalId
            draft.page = 1
            break;
        case CHANGE_PARTICIPANT_NAME:
            draft.participantName = action.participantName
            draft.disableParticipantName = action.disableParticipantName;
            draft.page = 1
            break;
        case CHANGE_ID:
            draft.documentId = action.value ? action.value.map(v => v.value) : [];
            draft.page = 1
            break;
        case CHANGE_MEMBERS:
            draft.selectedUsers = action.value || [];
            draft.page = 1
            break;
        case CHANGE_CREATOR:
            draft.selectedCreators = action.value || [];
            draft.page = 1
            break;
        case CHANGE_GROUPS:
            draft.selectedGroups = action.value || [];
            draft.page = 1
            break;
        case CHANGE_STATUS:
            draft.status = action.value || [];
            draft.page = 1
            break;
        case CHANGE_IS_APPLICATION:
            draft.isApplication = !draft.isApplication
            draft.page = 1
            break;
        case NEXT_PAGE:
            if (draft.page < draft.pages) {
                draft.page = draft.page + 1
            }
            break;
        case PREVIOUS_PAGE:
            if (draft.page > 1) {
                draft.page = draft.page - 1
            }
            break;
        case GO_TO_PAGE:
            if (draft.page !== action.page) {
                draft.page = action.page
            }
            break;
        case CHANGE_DATE:
            draft.startDate = action.startDate;
            draft.endDate = action.endDate;
            draft.key = action.key;
            draft.page = 1
            break;
        case SET_PROPERTIES:
            draft.header = action.header;
            draft.pages = action.pages;
            break;
        case RESET:
            return initialState();
    }
}, {})


function ReportProvider({ children }) {
    const [state, dispatch] = useReducer(reducer, initialState());

    return (
        <ReportStateContext.Provider value={{ ...state }}>
            <ReportDispatchContext.Provider value={dispatch}>
                {children}
            </ReportDispatchContext.Provider>
        </ReportStateContext.Provider>
    )
}

function useReportState() {
    const context = useContext(ReportStateContext)
    if (context === undefined) {
        throw new Error('useReportState must be used within a ReportProvider')
    }
    return context
}

function useReportDispatch() {
    const context = useContext(ReportDispatchContext)
    if (context === undefined) {
        throw new Error('useReportDispatch must be used within a ReportProvider')
    }
    return context
}


function useReport() {
    return [useReportState(), useReportDispatch()]
}

export { ReportProvider, useReport, useReportState, useReportDispatch }
